import { createContext, useContext, ReactNode } from 'react';

// Import types
import type { PacketWithPriceAndChannels } from 'types/views/configurator';

// Import helpers
import { checkIsIncluded } from 'components/views/offer_configurator/helpers/packets';

// Import hooks
import { useConfiguratorContext } from 'components/context/configurator/ConfiguratorProvider';

type Props = {
	children: ReactNode;
	packet: PacketWithPriceAndChannels;
	onSelect: () => void;
	isSelected?: boolean;
	isPricesLoading: boolean;
};

type ContextType = {
	packet: PacketWithPriceAndChannels;
	onSelect: () => void;
	isOwned: boolean;
	isIncludedSelectedMain: boolean;
	isIncludedInCurrentMain: boolean;
	isSelected: boolean;
	isDisabled: boolean;
	till: string | undefined;
	isPricesLoading: boolean;
};

export const PremiumPacketContext = createContext<ContextType>({} as ContextType);

export const usePremiumPacketContext = () => useContext(PremiumPacketContext);

const PremiumPacketProvider = ({ children, packet, onSelect, isSelected = false, isPricesLoading }: Props) => {
	const { subscription, selectedMain, currentMain } = useConfiguratorContext();
	const isOwned = checkIsIncluded(packet.uuid, subscription?.premium);
	const isIncludedSelectedMain = checkIsIncluded(packet.uuid, selectedMain?.included_packets_products);
	const isIncludedInCurrentMain = checkIsIncluded(packet.uuid, currentMain?.included_packets_products);
	const isDisabled = isOwned || isIncludedSelectedMain || isIncludedInCurrentMain || isPricesLoading;

	return (
		<PremiumPacketContext.Provider
			value={{
				packet,
				isOwned,
				isIncludedSelectedMain,
				isIncludedInCurrentMain,
				onSelect,
				isSelected,
				isDisabled,
				isPricesLoading,
				till: subscription?.till
			}}
		>
			{children}
		</PremiumPacketContext.Provider>
	);
};

export default PremiumPacketProvider;
